import React, { useState } from 'react';
import { CandidateInput } from '../PollCreator/CandidateInput';

interface NominateCandidateProps {
  onNominate: (names: string[]) => void;
  onCancel: () => void;
}

export function NominateCandidate({ onNominate, onCancel }: NominateCandidateProps) {
  const [candidates, setCandidates] = useState<string[]>(['']);
  const [lastAddedIndex, setLastAddedIndex] = useState<number | null>(0);

  const addCandidate = () => {
    const newIndex = candidates.length;
    setCandidates([...candidates, '']);
    setLastAddedIndex(newIndex);
  };

  const handleCandidateEnter = (index: number) => {
    if (index === candidates.length - 1) {
      addCandidate();
    }
  };

  const updateCandidate = (index: number, value: string) => {
    const newCandidates = [...candidates];
    newCandidates[index] = value;
    setCandidates(newCandidates);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validCandidates = candidates.filter(c => c.trim() !== '');
    if (validCandidates.length > 0) {
      onNominate(validCandidates);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 dark:text-white">Nominate Candidates</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          {candidates.map((candidate, index) => (
            <CandidateInput
              key={index}
              value={candidate}
              index={index}
              showRemove={false}
              onChange={updateCandidate}
              onRemove={() => {}}
              onEnter={handleCandidateEnter}
              autoFocus={index === lastAddedIndex}
            />
          ))}
          
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}